module.exports = __webpack_public_path__ + "img/B11.cdec1875.png";